/* eslint-disable eqeqeq */
import moment from 'moment';
import MessageActionsMenu from '../actions-menu/MessageActionsMenu';
import { memo, useMemo } from 'react';
import CRMTaskForm from './CRMTaskForm';
import { useTranslation } from 'react-i18next';

const CRMTaskMessage = ({ data = {}, refetchFn = () => {} }) => {
  const { t } = useTranslation();
  return (
    <div
      className={'task-wrapper flex items-center relative'}
      id={`task-${data?.id}`}
    >
      <div
        className={`task-icon text-base leading-4 border-2 ${
          data?.status == 1 ? 'border-red-600' : 'border-gray-400'
        } text-gray-400 rounded-full w-[42px] h-[42px] min-w-[42px] min-h-[42px] flex items-center justify-center mr-3`}
      >
        <i
          className={`bi ${
            data?.status == 1 ? 'bi-clock text-red-600' : 'bi-journal-bookmark'
          } text-lg leading-none`}
        />
      </div>
      <div className='task-details w-full'>
        <div className='text-[12px] text-gray-500 flex flex-col'>
          <div>
            {moment(data?.created_at).format('DD.MM.YYYY HH:mm')},{' '}
            {t('crm.leadHistory.staff')}:{' '}
            <span className='font-semibold text-gray-700'>{data?.name}</span>
            ,&nbsp;{t('crm.leadHistory.date')}:{' '}
            <span className='font-semibold text-gray-700'>
              {moment(data?.date).format('DD.MM.YYYY HH:mm')}
            </span>
          </div>
        </div>
        <div
          className={`my-1  ${
            data?.status == 2 ? 'line-through text-gray-400' : ''
          }`}
        >
          {data?.subt?.name || ''}
          {data?.subt?.name && data?.title ? ' - ' : ''}
          <TextWithPreservedLink text={data?.title} />
        </div>
        {data?.status == 1 && <CRMTaskForm refetch={refetchFn} data={data} />}
      </div>
      <MessageActionsMenu itemId={data?.id} refetchFn={refetchFn} />
    </div>
  );
};
export default memo(CRMTaskMessage);

const URL_REGEX =
  /(https?:\/\/[^\s]+|www\.[^\s]+|[a-zA-Z0-9-]+\.[a-zA-Z]{2,}[^\s]*)/g;

function normalizeUrl(match) {
  return /^https?:\/\//i.test(match) ? match : `https://${match}`;
}

function TextWithPreservedLink({ text = '', className = '' }) {
  if (!text) {
    return <div className='p-4 text-gray-500'>Matn yo'q</div>;
  }

  const parts = [];
  let lastIndex = 0;
  let keyIndex = 0;

  // Har bir linkni topib, bo‘lamiz
  const matches = text.matchAll(URL_REGEX);
  let hasMatch = false;

  for (const match of matches) {
    hasMatch = true;
    const matchText = match[0];
    const offset = match.index;

    // Link oldidagi matn
    if (offset > lastIndex) {
      parts.push(<span key={keyIndex++}>{text.slice(lastIndex, offset)}</span>);
    }

    // Linkni <a> qilamiz
    const url = normalizeUrl(matchText);
    parts.push(
      <a
        key={keyIndex++}
        href={url}
        target='_blank'
        rel='noopener noreferrer'
        className='text-blue-600 hover:underline font-medium'
      >
        {matchText}
      </a>
    );

    lastIndex = offset + matchText.length;
  }

  // Oxirgi matn qismi
  if (lastIndex < text.length) {
    parts.push(<span key={keyIndex++}>{text.slice(lastIndex)}</span>);
  }

  // Agar hech qanday link topilmasa, oddiy matn
  if (!hasMatch) {
    parts.push(<span key={keyIndex++}>{text}</span>);
  }

  return parts;
}
